import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BecomeOurPartnerInfo from "./component";
import { resetPartnerSelections } from "../become-our-partner-form/actions";
import { setName, setEmail, setMobile } from "../../configuration/actions";

const mapStateToProps = ({
    config: {
        storeCount,
        cityCount
    }
}) => ({
    storeCount,
    cityCount
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetPartnerSelectionsConnect: resetPartnerSelections,
    setNameConnect: setName,
    setMobileConnect: setMobile,
    setEmailConnect: setEmail
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BecomeOurPartnerInfo);
